/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PredictedCategory
 */
export interface PredictedCategory {
    /**
     * 
     * @type {string}
     * @memberof PredictedCategory
     */
    categoryId: string;
    /**
     * 
     * @type {string}
     * @memberof PredictedCategory
     */
    familyId: string;
    /**
     * 
     * @type {string}
     * @memberof PredictedCategory
     */
    label: string;
}

/**
 * Check if a given object implements the PredictedCategory interface.
 */
export function instanceOfPredictedCategory(value: object): value is PredictedCategory {
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    if (!('familyId' in value) || value['familyId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function PredictedCategoryFromJSON(json: any): PredictedCategory {
    return PredictedCategoryFromJSONTyped(json, false);
}

export function PredictedCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PredictedCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryId': json['categoryId'],
        'familyId': json['familyId'],
        'label': json['label'],
    };
}

export function PredictedCategoryToJSON(value?: PredictedCategory | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'categoryId': value['categoryId'],
        'familyId': value['familyId'],
        'label': value['label'],
    };
}

